import { Pill } from "@clipboard-health/ui-components";

export function ShiftUnavailablePill() {
  return (
    <Pill disabled label="Shift is unavailable" iconType="info" sx={{ width: "fit-content" }} />
  );
}
